var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeSpend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1V5C6 6.64453 7.35547 8 9 8H11V14.7188C11 17.7266 12.4961 20.5508 15 22.2188L19.1875 25L15 27.7812C12.4961 29.4492 11 32.2734 11 35.2812V42H9C7.35547 42 6 43.3555 6 45V49H44V45C44 43.3555 42.6445 42 41 42H39V35.2812C39 32.2734 37.5039 29.4492 35 27.7812L30.8125 25L35 22.2188C37.5039 20.5508 39 17.7266 39 14.7188V8H41C42.6445 8 44 6.64453 44 5V1H6ZM8 3H42V5C42 5.56641 41.5664 6 41 6H9C8.43359 6 8 5.56641 8 5V3ZM13 8H37V14.7188C37 17.0586 35.8242 19.2344 33.875 20.5312L28.4375 24.1562L27.1875 25L28.4375 25.8438L33.875 29.4688C35.8242 30.7695 37 32.9414 37 35.2812V42H34.9375C34.2188 33.8672 25 30.7812 25 30.7812C25 30.7812 15.7852 34.0234 15.0625 42H13V35.2812C13 32.9414 14.1758 30.7695 16.125 29.4688L21.5625 25.8438L22.8125 25L21.5625 24.1562L16.125 20.5312C14.1758 19.2344 13 17.0586 13 14.7188V8ZM9 44H41C41.5664 44 42 44.4336 42 45V47H8V45C8 44.4336 8.43359 44 9 44Z",
    fill: "#29CC8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSpend);
export default __webpack_public_path__ + "static/media/TimeSpend.c005ae11d8b16b1917f508f158d7c751.svg";
export { ForwardRef as ReactComponent };